import { Box, useTheme } from '@mui/material';

export const LearningPathProgressImage = ({
  src,
  durationTotal,
  durationPlayed,
}: {
  src: string;
  durationTotal: number;
  durationPlayed: number;
}) => {
  const theme = useTheme();

  const progressPercent = Math.min(durationPlayed / durationTotal, 1) * 100;
  const imageWidth = 230;
  const radius = imageWidth / 2;
  const stroke = 10;
  const strokeGap = 2;
  const offsetImageWidth =
    progressPercent > 0 ? imageWidth - (stroke + strokeGap) * 2 : imageWidth;
  const normalizedRadius = radius - stroke / 2;
  const strokeColor = theme.palette.secondary.main;
  const circumference = 2 * Math.PI * normalizedRadius;
  const strokeDashoffset =
    circumference - (progressPercent / 100) * circumference;

  return (
    <Box sx={{ position: 'relative', display: 'flex' }}>
      <Box
        sx={[
          styles.progressContainer,
          { visibility: progressPercent > 0 ? 'visible' : 'hidden' },
        ]}>
        <svg height={radius * 2} width={radius * 2}>
          <circle
            cx={radius}
            cy={radius}
            fill="none"
            r={normalizedRadius}
            stroke={strokeColor}
            strokeDasharray={`${circumference}, ${circumference}`}
            strokeWidth={stroke}
            style={{ strokeDashoffset }}
            transform={`rotate(90, ${radius}, ${radius})`}
          />
        </svg>
      </Box>
      <Box
        sx={{
          position: 'relative',
          width: offsetImageWidth,
          height: offsetImageWidth,
          m: `${progressPercent > 0 ? stroke + strokeGap : 0}px`,
          overflow: 'hidden',
          borderRadius: '50%',
        }}>
        <Box
          sx={styles.coverImage}
          component="img"
          src={src}
          alt="learning path cover"
        />
        <Box sx={styles.imageOverlay} />
      </Box>
    </Box>
  );
};

const styles = {
  progressContainer: {
    backgroundColor: 'grey50',
    borderRadius: '50%',
    display: 'flex',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  coverImage: {
    transition: 'transform .25s ease-in-out',
    height: '100%',
    transform: 'scale(1.005)',
  },
  imageOverlay: {
    position: 'absolute',
    top: 0,
    backgroundColor: 'secondary.main',
    opacity: 0.05,
    height: '100%',
    width: '100%',
  },
};
